import { useEffect } from 'react'

import { useAgentDetailsWF, useGetAgentBanners } from '@zet/customer'
import { setNativewindColors } from '@zet/design-system/tailwind/utils'
import storageUtil from '@zet/utils/storage'

import { useFontFlowStore } from '../../store/fontFlowStore'
import { bmsUserIds, jfsUserIds } from '../utils/constants'

const useGetAgentDetailsAndTheme = () => {
  const { data: agentData, isLoading } = useAgentDetailsWF()
  const setJfsFlow = useFontFlowStore((state) => state.setJfsFlow)

  const onecode = agentData?.onecode
  const onecodeId = Number(agentData?.onecodeId)

  const { data: bannerData } = useGetAgentBanners({ onecode })

  const isBMSFlow = bmsUserIds.includes(onecodeId)
  const isJfsFlow = jfsUserIds.includes(onecodeId)

  setJfsFlow(isJfsFlow)

  const {
    imageUrl: bannerImage,
    topProductTitle,
    nonTopProductTitle,
    theme,
  } = bannerData || {}

  useEffect(() => {
    if (!theme) return
    const themeVars: Record<string, string | undefined> = {
      '--color-primary-100': theme.primary100,
      '--color-primary-10': theme.primary10,
      '--color-primary-200': theme.primary200,
      '--color-primary-150': theme.primary150,
      '--color-secondary-600': theme.secondary600,
      '--color-white-14': theme.white14,
      '--color-grays-80': theme.grays80,
      '--color-grays-40': theme.grays40,
      '--color-warning-100': theme.warning100,
      '--color-grays-20': theme.grays20,
      '--color-secondary-100': theme.secondary100,
      '--color-secondary-150': theme.secondary150,
      '--color-secondary-50': theme.secondary50,
      '--color-secondary-10': theme.secondary10,
      '--color-error-100': theme.error100,
    }

    Object.entries(themeVars).forEach(([key, value]) => {
      if (typeof value === 'string' && value.trim()) {
        storageUtil.deleteObject(key)
        storageUtil.saveObject(key, value)
        setNativewindColors({ [key]: value })
      }
    })
  }, [theme])

  return {
    agentData,
    isLoading,
    bannerImage,
    topProductTitle,
    nonTopProductTitle,
    isBMSFlow,
    isJfsFlow,
  }
}

export default useGetAgentDetailsAndTheme
